import { Injectable } from '@angular/core';
import { SidebarService } from '../../../shared/sidebar/sidebar.service';
import { Point } from 'geojson';
import { MapElement } from '../../../shared/map/map-element.model';
import { MeasurementsTableComponent } from '~app/measurements/measurements-table/measurements-table.component';
import { MapService } from '~app/shared/map/map.service';

@Injectable({
  providedIn: 'root'
})
export class MeasurementsActionService {
  constructor(
    private sidebarService: SidebarService,
    private mapService: MapService,
  ) {

  }

  public openDetails(feature: MapElement<Point>): void {
    this.mapService.changeCurrentFeature(feature);
    this.sidebarService.requestSidebarPanel(MeasurementsTableComponent.getComponentName());
  }
}
